var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.19 15.403"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Arrow Icon",
    d: "M10.854.738l6.026 6.963-6.026 6.963.853.738 6.345-7.332a.564.564 0 000-.738L11.707 0zM0 8.265h14.1V7.137H0z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "480436e54ef5471b7b402fc77a641a1f.svg";
export { SvgArrowIcon as ReactComponent };